<template>
  <div class="actress-action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="100px">
        <div class="item-box">
          <div class="item-left">
            <el-form-item label="姓名:" prop="">
              <el-input size="small" placeholder="请输入姓名" v-model="params.name"></el-input>
            </el-form-item>
            <el-form-item label="中文名:" prop="">
              <el-input size="small" placeholder="请输入中文名" v-model="params.name"></el-input>
            </el-form-item>
            <el-form-item label="人气:" prop="">
              <el-input size="small" placeholder="请输入人气" v-model="params.name"></el-input>
            </el-form-item>
            <el-form-item label="三围:" prop="">
              <el-input size="small" placeholder="请输入三围" v-model="params.name"></el-input>
            </el-form-item>
            <el-form-item label="罩杯:" prop="platform">
              <el-select size="small" placeholder="请选择罩杯" style="width: 250px" v-model="params.name">
                <el-option :label="item.label" :value="item.value" v-for="item in cupList" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="作品" prop="">
              <el-input size="small" placeholder="请输入作品" v-model="params.name"></el-input>
            </el-form-item>
            <el-form-item label="评分:" prop="">
              <el-input size="small" placeholder="请输入评分" v-model="params.name"></el-input>
            </el-form-item>
          </div>
          <div class="item-right">
            <el-form-item label="封面:" prop="">
              <base-upload :cover="params.cover" :action="action" @successCallback="successCallback" :wSize="360" :hSize="480" :width="'180px'" :height="'240px'"></base-upload>
            </el-form-item>
          </div>
          <div class="item-right">
            <el-form-item label="头像:" prop="portrait">
              <base-upload :cover="params.portrait" :action="action" @successCallback="successCallback" :wSize="360" :hSize="360"></base-upload>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="简介:" prop="">
          <el-input size="small" type="textarea" :rows="3" placeholder="请输入简介"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      flag: false,
      // 罩杯选择
      cupList: [
        {
          label: 'A',
          value: 1
        },
        {
          label: 'B',
          value: 2
        },
        {
          label: 'C',
          value: 3
        },
        {
          label: 'D',
          value: 4
        },
        {
          label: 'E',
          value: 5
        },
        {
          label: 'F',
          value: 6
        },
        {
          label: 'G',
          value: 7
        },
        {
          label: 'H',
          value: 8
        },
        {
          label: 'I',
          value: 9
        },
      ],
      params: {
        name: '',
        number: 0,
        status: false,
        cover: '',
        portrait: ''
      },
      // 图片上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
    }
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false
      this.params = {
        number: 0,
        status: false
      }
    },
    open(type) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑女优'
      } else {
        this.title = '新增女优'
      }
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },

  }
}
</script>
<style scoped lang="scss">
.item-box {
  display: flex;
  justify-content: flex-start;
}
</style>